import { render, staticRenderFns } from "./Commission.vue?vue&type=template&id=2da0a1ca&scoped=true&web=true&"
import script from "./Commission.vue?vue&type=script&lang=ts&"
export * from "./Commission.vue?vue&type=script&lang=ts&"
import style0 from "./Commission.vue?vue&type=style&index=0&id=2da0a1ca&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da0a1ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDatePicker,VMenu,VRow,VTextField})
